export default "__VITE_ASSET__DsRTtNqX__"